/* eslint-disable no-unused-vars */
import * as React from "react";
/* eslint-enable no-unused-vars */
import { connect } from "react-redux";
import { IApplicationState } from "../../models/store/storeTypes";
import * as storeActions from "../../models/store/storeActions";
import * as storeEffects from "../../models/store/storeEffects";
import { Base } from "ui/Scripts/source/framework/base";
import { DocumentList, IDocumentListOwnProps, IDocumentListStateProps, IDocumentListDispatchProps } from "../../components/document/documentList";

export function mapStateToProps(applicationState: IApplicationState, ownProps: IDocumentListOwnProps): IDocumentListStateProps {
    if (Base.isNullOrUndefined(applicationState) || Base.isNullOrUndefined(applicationState.event) || Base.isNullOrUndefined(applicationState.event.eventList)) {
        return {
            user: null,
            hasMore: true,
            isLoading: false,
            page: 0,
            companyId: "",
            parent: null,
            items: [],
            favoriteIds: [],
            companies: [],
            filter: "",
            sortColumn: "",
            sortOrderIsAsc: true,
            lastOpenedDocumentId: "",
        };
    }
    const documentList = applicationState.document.documentList;
    return {
        user: applicationState.user,
        hasMore: documentList.hasMore,
        isLoading: documentList.isLoading,
        page: documentList.page,
        companyId: documentList.companyId,
        parent: documentList.parent,
        items: documentList.items,
        favoriteIds: documentList.favoriteIds,
        companies: documentList.companies,
        filter: documentList.filter,
        sortColumn: documentList.sortColumn,
        sortOrderIsAsc: documentList.sortOrderIsAsc,
        lastOpenedDocumentId: documentList.lastOpenedDocumentId,
    };
}

export function mapDispatchToProps(dispatch: storeEffects.DocumentThunkDispatch): IDocumentListDispatchProps {
    return {
        loadDocuments: (folderId: string, companyId: string, page: number, filter: string, sortColumn: string, sortOrderIsAsc: boolean) => dispatch(storeEffects.getDocumentList(folderId, companyId, page, filter, sortColumn, sortOrderIsAsc)),
        searchDocuments: (folderId: string, companyId: string, page: number, filter: string, sortColumn: string, sortOrderIsAsc: boolean) => dispatch(storeEffects.searchDocuments(folderId, companyId, page, filter, sortColumn, sortOrderIsAsc)),
        resetDocuments: () => dispatch(storeActions.documentListReset()),
        setLastOpenedDocumentId: (id: string) => dispatch(storeActions.documentListSetLastOpened(id)),
        setReturnUrl: (url: string) => dispatch(storeActions.documentViewSetReturnUrl(url)),
        addFavorite: (id: string, companyId: string) => dispatch(storeEffects.addFolderToFavorites(id, companyId)),
        removeFavorite: (id: string, companyId: string) => dispatch(storeEffects.removeFolderFromFavorites(id, companyId)),
        onLogout: () => dispatch(storeEffects.logout())
    };
}

export default connect<IDocumentListStateProps, IDocumentListDispatchProps, IDocumentListOwnProps>(mapStateToProps, mapDispatchToProps)(DocumentList);